import { gql } from "@apollo/client"

const UPDATE_NOTIFICATION_MUTATION = gql`
  mutation($input: UpdateNotificationInput!) {
    updateNotification(input: $input) {
      id
      title
      description
      active
    }
  }
`

export { UPDATE_NOTIFICATION_MUTATION }